<script setup lang="ts">
import { toastService } from '@/services/ToastService';
const toasts = toastService.toasts;
</script>

<template>
  <div class="toast-stack-container" aria-live="polite">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="['toast', 'align-items-center', 'text-white', 'border-0', toast.color, 'show']"
      role="alert"
      aria-atomic="true"
    >
      <div class="d-flex align-items-center">
        <div class="toast-body d-flex align-items-center flex-grow-1">
          <span class="flex-grow-1" style="white-space: pre-line">{{ toast.message }}</span>
          <div v-if="toast.loading" class="spinner-border text-white ms-2 flex-shrink-0" role="status">
            <span class="visually-hidden">Bezig…</span>
          </div>
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto flex-shrink-0"
          aria-label="Sluiten"
          @click="toastService.remove(toast.id)"
        ></button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.toast-stack-container {
  position: fixed;
  top: calc(var(--kl-navbar-height) + 0.75rem);
  right: 1rem;
  z-index: 1080;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 420px;
}
.toast {
  min-width: 300px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  max-height: 40vh;
  overflow-y: auto;
}
/* lange foutmeldingen (JSON/URL's) binnen de ballon laten afbreken */
.toast-body {
  overflow-wrap: anywhere;
}
.spinner-border {
  width: 1.25rem;
  height: 1.25rem;
  border-width: 0.2em;
}
@media (max-width: 576px) {
  .toast-stack-container {
    left: 0.5rem;
    right: 0.5rem;
    max-width: calc(100% - 1rem);
  }
  .toast {
    min-width: unset;
    width: 100%;
  }
}
</style>
